import $ from 'jquery';
import _ from 'underscore';
import BaseView from 'picnic/core/views/Base';
import CheckAllLink from 'app/cms/carpricechecker/views/appointmentsSelect/CheckAllLink';
import FilterGroup from 'app/cms/carpricechecker/views/appointmentsSelect/FilterGroup';
import Appointments from 'app/cms/carpricechecker/views/appointmentsSelect/Appointments';


const
	OPEN_CLASS = 'is-open',
	FILLED_CLASS = 'is-filled',
	RESET_ALL_FILTER_TEXT = 'alle Filter zurücksetzen',
	APPOINTMENT_SELECT_CLASS = 'appointments-select'
;


class View extends BaseView {

	constructor(options) {
		super(options);

		this._allInputs = [...this.el.getElementsByTagName('input')];

		_.bindAll(
			this,
			'_onClickOutside',
			'_onToggleInGroup',
			'_onToggleAll'
		);

		$(document).on('click', this._onClickOutside);
	}

	get _checkedOptionsValues() {
		return this._filterGroups.map(filterGroup => filterGroup.checkedOptions).reduce((acc, val) => acc.concat(val));
	}

	get allChecked() {
		return this._filterGroups.filter(filterGroup => filterGroup.isAllChecked === true).length === this._filterGroups.length;
	}

	render() {
		super.render();

		this._renderCheckAllLink();
		this._renderFilterGroups();

		return this;
	}

	events() {
		return {
			'click': this._onTogglePullDown
		};
	}

	_renderCheckAllLink() {
		var view = new CheckAllLink({
			el: this.el.getElementsByTagName('ul')[0],
			context: this.context,
			title: 'Alle auswählen'
		}).render();

		view.on('click', this._onToggleAll);

		this._checkAllLink = view;
	}

	_renderFilterGroups() {
		var
			views = []
		;

		[...this.el.getElementsByTagName('ul')].forEach(list => {
			var view = new FilterGroup({
				el: list,
				context: this.context
			}).render();

			view.on('toggle', this._onToggleInGroup);

			views.push(view);
		});

		this._filterGroups = views;
	}

	_renderAppointments(checkedValues) {
		var view = new Appointments({
			el: this.el,
			context: this.context,
			textArray: checkedValues
		}).render();

		this.$el.toggleClass(FILLED_CLASS, true);

		this._appointments = view;
	}

	_destroyAppointments() {
		this._appointments.destroy();
		this._appointments = undefined;
		delete(this._appointments);

		this.$el.toggleClass(FILLED_CLASS, false);
	}

	_toggleDropDown() {
		this.$el.toggleClass(OPEN_CLASS, !this.$el.hasClass(OPEN_CLASS));
	}

	_updateAppointments() {
		var
			checkedValues = this._checkedOptionsValues
		;

		if (this._appointments && checkedValues.length > 0) {
			this._appointments.updateText(checkedValues);
		} else if (this._appointments && checkedValues.length === 0) {
			this._destroyAppointments();
		} else if (checkedValues.length > 0) {
			this._renderAppointments(checkedValues);
		}
	}

	_onTogglePullDown(event) {
		var $el = $(event.target);

		if (!$el.closest('.' + APPOINTMENT_SELECT_CLASS) || !$el.hasClass(APPOINTMENT_SELECT_CLASS)) {
			this._toggleDropDown();
		}
	}

	_onToggleAll() {
		this._checkAllLink.toggleText(!this.allChecked ? RESET_ALL_FILTER_TEXT : undefined);
		this._filterGroups.forEach(filterGroup => filterGroup.toggleCheckAll(!this.allChecked));
		this._updateAppointments();
	}

	_onToggleInGroup() {
		this._checkAllLink.toggleText(this.allChecked ? RESET_ALL_FILTER_TEXT : undefined);
		this._updateAppointments();
	}

	_onClickOutside(event) {
		if (this.$el.hasClass(OPEN_CLASS) && $(event.target).closest(this.$el).length === 0) {
			this._toggleDropDown();
		}
	}

}

export default View;
